import React from 'react';
import './gallery.style.scss';

import Gallery from '../../components/gallery/gallery-component.jsx';

const GalleryPage = () => {
  return (
    <React.Fragment>
      <h1 className='gallery-page-heading'> Gallery</h1>
      <Gallery />
    </React.Fragment>
  );
};

export default GalleryPage;
